import { render, staticRenderFns } from "./MarkedQuality.vue?vue&type=template&id=f97c7b26&scoped=true&"
import script from "./MarkedQuality.vue?vue&type=script&lang=js&"
export * from "./MarkedQuality.vue?vue&type=script&lang=js&"
import style0 from "./MarkedQuality.vue?vue&type=style&index=0&id=f97c7b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97c7b26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
